// extracted by mini-css-extract-plugin
export default {"d-contents":"RailsPartial-module__d-contents__ndI3zHZ"};